import { Group, User } from '@frontend-site/shared/data';

export class Comment {
    order?: number;
    createdBy: string = '';
    createdAt?: number;
    editedAt?: number;
    text: string = '';
    state: string = '';
    type?: string;
    additionalInfo?: string;
    guid?: string;
    _mentionedUsers?: Map<string, User>;
    _mentionedGroups?: Map<number, Group>;
}
